import './App.css';
import ThalaReviewSystem from './components/ThalaReviewSystem';

function App() {
  return (
    <div className="App">
      <ThalaReviewSystem/>
    </div>
  );
}

export default App;
